// removed by extract-text-webpack-plugin
module.exports = {"buttons":"change-doctype-modal__buttons___2EDZ7"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/change-doctype-modal.scss
// module id = 1319
// module chunks = 0